// post pricing elements (subtotal, discount, recurring pricing, etc.)
const discountEl = document.querySelector('#productV2PurchaseDiscount');
const discountAmt = discountEl.querySelector('#productV2PurchaseDiscountInfoPrice');
const recurringEl = document.querySelector('#productV2Learn .recurring');
const subtotal = document.querySelector('#productV2PurchaseSubtotalPrice');


// circular check SVG; fill follows the element's text color so CSS owns the state
const checkSVG = `<svg class="checkIcon" width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.564 0.0547104C6.55781 0.422704 2.98055 2.84718 1.21414 6.39137C-0.142199 9.11287 -0.374077 12.2957 0.578651 15.1136C2.31592 20.2512 7.32694 23.4731 12.7562 22.9432C17.9338 22.438 22.1221 18.5649 23.0256 13.447C23.2114 12.3943 23.2111 10.6368 23.0248 9.57238C22.79 8.23041 21.9977 6.10249 21.7329 6.10249C21.6685 6.10249 21.3742 6.35168 21.079 6.65619L20.5423 7.2098L20.7881 7.81865C21.4097 9.35817 21.6547 11.4434 21.3993 13.0224C21.0514 15.1746 20.0471 17.0691 18.4476 18.5906C15.6793 21.2239 11.9256 22.0266 8.2383 20.7735C6.5156 20.1881 4.7307 18.8636 3.55553 17.2987C3.03228 16.6018 2.30649 15.1102 2.00214 14.1064C1.76615 13.3279 1.74972 13.1589 1.74972 11.5155C1.74972 9.86663 1.7655 9.70572 2.00429 8.92467C2.51614 7.25061 3.26164 5.95657 4.3905 4.78273C6.25524 2.84367 8.4599 1.83907 11.171 1.69315C13.2465 1.58146 15.3381 2.16709 17.1405 3.36471C17.4941 3.59964 17.7909 3.78081 17.8002 3.7674C17.8095 3.75398 18.0207 3.4565 18.2697 3.10645L18.7222 2.46994L18.419 2.22473C17.4699 1.45729 15.4602 0.570382 13.9845 0.267715C13.1482 0.0962567 11.3388 -0.0164454 10.564 0.0547104ZM26.2529 0.264384C24.0949 1.06523 21.7057 2.49372 19.5291 4.28446C17.2079 6.19419 14.1345 9.66297 12.4869 12.2326C12.2993 12.5252 12.1132 12.7647 12.0734 12.7647C12.0335 12.7647 11.562 12.2616 11.0256 11.6466C10.4892 11.0317 9.93046 10.3967 9.78394 10.2355C9.63741 10.0744 9.2013 9.57821 8.81496 9.13286C8.42853 8.68761 8.07693 8.32322 8.0335 8.32322C7.99008 8.32322 7.47897 8.66679 6.89764 9.0866C6.31631 9.50641 5.73722 9.91826 5.61087 10.0018L5.38105 10.1537L5.5752 10.3719C8.50071 13.6607 12.2855 17.8538 12.3283 17.8535C12.3595 17.8533 12.4652 17.6556 12.5631 17.414C12.9114 16.555 13.949 14.4761 14.6022 13.3285C16.3702 10.2227 18.1258 7.92331 20.5492 5.53935C22.4539 3.66561 24.6928 1.97814 26.4163 1.11714L27 0.825581V0.410582C27 0.18231 26.9894 -0.00247328 26.9767 2.50384e-05C26.9639 0.00243083 26.6381 0.121425 26.2529 0.264384Z" fill="currentColor"/>
</svg>`


/***************************************** Slideshow *****************************/

// slideshow
new Swiper("#productV2Swiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3500,
    },
    navigation: {
        nextEl: '#productV2SwiperRight',
        prevEl: '#productV2SwiperLeft',
    },
    on: {
        slideChange: function () {
            document.querySelector('#productV2SwiperIndex span').innerHTML = this.realIndex + 1;
        }
    }
})

/***************************************** FAQ Slider *****************************/

// flag used to help prevent accidental outside close click
let reviewsTransitioning = false;

// setup reviews swipers for all faq items that contain it
let reviewSwipers = document.querySelectorAll('.productV2SliderReviews.swiper');
reviewSwipers.forEach(swiper => {
    new Swiper(swiper, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        breakpoints: {
            801: {
                spaceBetween: 20
            }
        },
        on: {
            sliderMove: function () {
                // update the upsells transitioning flag - only once
                if (reviewsTransitioning) {
                    return;
                }
                reviewsTransitioning = true;
            },
            transitionEnd: function () {
                // update the upsells transitioning flag - only once
                reviewsTransitioning = false;
            }
        }
    })
})

// get the buttons
let nextBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationNext`);
let prevBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationPrev`);

// true while the close animation is running
let closing = document.querySelector('#productV2Slider').classList.contains('isClosing');

// open slider on 'learn more' click
document.querySelector('#productV2FAQ').addEventListener('click', function () {
    // if the slider is still closing, prevent click
    if (closing) return;

    let sliderFaqs = document.querySelectorAll('.productV2SliderContentItem');
    let foundActive = [...sliderFaqs].some(faq => faq.classList.contains('active'))
    // show the first element if there was no active one before
    !foundActive ? document.querySelector('.productV2SliderContentItem').classList.add('active') : '';

    // call the open slider function
    openSlider();
})

// make next question active
nextBtn.onclick = () => {
    helperFunction(true)
};
prevBtn.onclick = () => {
    helperFunction(false)
};

// helper function for faqs slider nav
function helperFunction(goNext) {
    // needed variables
    let targetEl = "";
    let currentEl = document.querySelector('.productV2SliderContentItem.active');
    let currentIndex = "";
    let numEls = document.querySelectorAll('.productV2SliderContentItem');

    // get the current index
    numEls.forEach((el, index) => {
        if (el.classList.contains('active')) {
            currentIndex = index;
        }
    })

    // no element? exit
    if (!currentEl || numEls.length === 1) {
        return;
    }

    if (currentIndex === numEls.length - 1 && goNext === true) {
        // loop to start if at end
        targetEl = numEls[0];
    } else if (currentIndex === 0 && goNext === false) {
        // loop to end if at start
        targetEl = numEls[numEls.length - 1];
    } else {
        // determine if we need next or previous sibling
        targetEl = goNext === true ? currentEl.nextElementSibling : currentEl.previousElementSibling;
    }
    if (targetEl != null) {
        currentEl?.classList.remove('active');
        targetEl?.classList.add('active');

        // update the dropdown to match the active faq
        let dropdownItem = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`);
        if (dropdownItem) {
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`)?.innerHTML;
            document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
                element.classList.remove("hidden");
                if (element.dataset.id === targetEl.dataset.id) {
                    element.classList.add("hidden");
                }
            });
        }
    }

    // scroll to top of slider content
    document.querySelector('#productV2SliderContent')?.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// open faqs dropdown nav on click
document.querySelector('#productV2SliderDropdownButton').addEventListener('click', function () {
    this.classList.toggle('active');
})

// change faq on dropdown select
document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(item => {
    item.addEventListener('click', function () {
        // change active faq
        document.querySelectorAll('.productV2SliderContentItem').forEach(faq => faq.classList.remove('active'));
        document.querySelector(`.productV2SliderContentItem[data-id="${this.dataset.id}"]`).classList.add('active');

        // show any hidden items in the dropdown from previous selection
        document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => element.classList.remove('hidden'));

        // hide the item in the dropdown that is currently selected
        this.classList.add('hidden')

        // change dropdown label
        // document.querySelector('#productV2SliderDropdownButton span').innerHTML = this.innerHTML;

        // close dropdown
        document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

        // scroll to top of slider content
        document.querySelector('#productV2SliderContent')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
});

// close slider on click
document.querySelector('#productV2SliderClose').addEventListener('click', function () {
    closeSlider();
})

/***************************************** End FAQ Slider *****************************/


// show hide the buy now button
window.addEventListener('scroll', function () {
    if (document.querySelector("#productV2ATC").getBoundingClientRect().top < 0) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();

    // scroll to top on desktop, otherwise scroll to title
    if (window.innerWidth > 800) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else {
        // scroll to the title which is essential the height of the productSwiper
        window.scrollTo({
            top: document.querySelector("#productV2Swiper").clientHeight - 60,
            behavior: 'smooth'
        });
    }
});

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productV2FormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        document.querySelectorAll(".productV2FormRowParent").forEach(item => item.classList.remove('active'));

        // sync action across all forms
        document.querySelectorAll(`.productV2FormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            // update atc lang
            refreshForm();

            // add active class to the parent
            element.closest(".productV2FormRowParent").classList.add('active');
        })
    });
})

/***************************************** FAQs *****************************/

document.querySelectorAll(".productV2FAQItemButton").forEach(button => {
    button.addEventListener("click", function () {
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }
        // remove active from all other faqs
        document.querySelectorAll(".productV2FAQItemButton").forEach(item => item.classList.remove("active"));
        this.classList.add("active");
    })
})


/***************************************** Slider Popup *****************************/

const slider = document.querySelector("#productV2Slider");

function openSlider() {
    // open slider modal
    slider.showModal();
    slider.classList.add("active");

    // update the dropdown to match the active faq
    let activeFAQ = document.querySelector('.productV2SliderContentItem.active').dataset.id;
    document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
        element.classList.remove("hidden");
        if (element.dataset.id === activeFAQ) {
            element.classList.add("hidden");
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = element.innerHTML;
        }
    });

    // no scroll on body
    document.querySelector('body').classList.add('noScroll');
}

function closeSlider() {
    // set closing class
    document.querySelector('#productV2Slider').classList.add('isClosing');

    // remove active from slider
    slider.classList.remove("active");

    // close dropdown if open
    document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

    // Wait a few before closing - animation needs to finish
    setTimeout(() => {
        // close modal
        slider.close();

        // remove no scroll
        document.querySelector('body').classList.remove('noScroll');

        // set closing flag to false
        document.querySelector('#productV2Slider').classList.remove('isClosing');
    }, 300)
}


let dropdown = document.querySelector('#productV2SliderDropdown');

// modal close and/or dropdown close on outside click
slider.addEventListener('click', function (e) {
    // make sure to also check this isn't an accidental outside close click
    if (e.target === this && reviewsTransitioning === false) {
        closeSlider();
    }
    if (!dropdown.contains(e.target)) {
        dropdown.querySelector('button').classList.contains('active') ? dropdown.querySelector('button').classList.remove('active') : "";
    }
})

// accessibility close
slider.addEventListener('close', function () {
    closeSlider();
})

// popup functionality
if (document.querySelector('#productV2SwiperPopups') !== null && window.innerWidth >= 800) {
    function popupImage() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                if (!entry.isIntersecting) return;
                // disconnect once entry is intersecting (visible)
                observer.disconnect();

                // collect the popup items
                const items = [...document.querySelectorAll('.productV2SwiperPopupsPopup.popupImg')];
                let i = 0;

                // infinite loop
                while (true) {
                    items[i].classList.add('active');
                    await sleep(5000);
                    items[i].classList.remove('active');
                    i = (i + 1) % items.length;
                }
            });
        }, {threshold: 0.5});

        // check to see if paper towel section is 50% in view
        observer.observe(document.querySelector('#productV2'));
    }

    // trigger popup function
    popupImage();
}

/***************************************** Rolls *****************************/

// rolls change event
document.querySelectorAll(".productV2FormRollsItem").forEach(function (element) {
    element.addEventListener("click", function () {
        let variant = this.getAttribute("variant");
        // change active product form
        document.querySelectorAll(".productV2Form.active").forEach(item => item.classList.remove('active'));
        document.querySelector(`.productV2Form[variant="${variant}"]`).classList.add("active");

        // update the selected frequency
        document.querySelector(`.productV2Form[variant="${variant}"]`).querySelector('.productV2FormFrequencySelectOption.default')?.click();
        updateSavings(document.querySelector(`.productV2Form[variant="${variant}"] .productV2FormFrequencySelectLabel`).innerText);

        refreshForm();
    });
})

/***************************************** Frequency *****************************/

// frequency open
document.querySelectorAll(".productV2FormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }

        // remove current frequency from dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            let currentSellingPlan = element.closest(".productV2FormFrequency").getAttribute("selling_plan");
            if (parseInt(element.getAttribute('selling_plan')) === parseInt(currentSellingPlan)) {
                element.classList.remove("active");
            }
        })

        // open dropdown
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productV2FormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productV2FormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");

        // re-add current frequency to dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            if (!element.classList.contains("active")) {
                element.classList.add("active");
            }
        })
    }
});

// frequency change
document.querySelectorAll(".productV2FormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productV2FormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productV2FormFrequencySelectLabel").innerHTML = this.innerHTML;
        updateSavings(this.querySelector("span").innerHTML);
    });
})

// frequency setup
// popular is the default
document.querySelector(".productV2Form.active .productV2FormFrequencySelectOption.default")?.click();

// update the savings per year for the subscription option based on the selected frequency
function updateSavings(cadence) {
    // get the cadence
    let cad = parseInt(cadence.match(/\d+/g)[0]);

    // get the active form
    let activeForm = document.querySelector('.productV2Form.active');

    // get the active form's price and compare price for subscription
    let price = activeForm.querySelector('.productV2FormPrice').dataset.subPrice;
    let comparePrice = activeForm.querySelector('.productV2FormPrice').dataset.price;

    // determine the difference in price between subscription and one time purchase
    let difference = (comparePrice - price) / 100;

    // determine how many times per year full deliveries can be made based on cadence
    let yearlyDeliveries = Math.floor((52 / cad));

    if (comparePrice) {
        // calculate savings per year and update the DOM
        let savings = difference * yearlyDeliveries;

        activeForm.querySelector('.productV2FormRowBenefitsSavings span').innerHTML = `Save $${savings} per year`;
    }
}

/**************************************** Upsell + ATC *************************************/

function refreshForm() {
    document.querySelector("#productV2ATC span").textContent = "Add to Cart";

    // get the active form, exit if we don't find one
    const activeForm = document.querySelector('.productV2Form.active');
    if (activeForm === null) {
        return;
    }

    // check if sold out
    if (activeForm.classList.contains("available")) {
        document.querySelector("#productV2ATC").classList.remove("disabled");
    } else {
        document.querySelector("#productV2ATC").classList.add("disabled");
    }

    // check if the current active form is set to the subscribe option
    const isSub = !!activeForm.querySelector('.productV2FormRadioInput[value="Subscribe"]:checked');
    const pricing = Number(activeForm.querySelector('.productV2FormPrice').dataset[isSub ? 'subPrice' : 'price']);

    // get the discount headline elements
    const discountHeadlines = document.querySelectorAll('.productV2FormDiscount');

    // the discount markup is gated on customer == nil, so it is absent for logged in customers
    const firstOrderEl = activeForm.querySelector('.productV2FormRowFirst');

    // calculate the total discount value
    const discountValue = Math.round(pricing * (welcomeDiscount.percent / 100));

    // first order is discounted, renewals are not, so these two prices are no longer the same number
    let firstOrderPrice = pricing;
    if (isSub) {
        firstOrderPrice = pricing - discountValue;
        // pdp figure is an estimate from the theme setting; the drawer shows shopify's real number
        discountEl.querySelector("#productV2PurchaseDiscountInfoCodeLabel").innerHTML = `${checkSVG} ${welcomeDiscount.code} ${welcomeDiscount.percent}% off`;

        // update the total amount taken off the first subscription order
        discountAmt.textContent = `-${price(discountValue)}`;
    }

    // update the price of the first subscription order with the discount
    subtotal.innerHTML = price(firstOrderPrice);

    // special variables for the first order element - they don't change based on the purchase option
    const subPricing = Number(activeForm.querySelector('.productV2FormPrice').dataset.subPrice);
    const subDiscount = Math.round(subPricing * (welcomeDiscount.percent / 100));
    firstOrderEl.innerHTML = `First order ${price(subPricing - subDiscount)}`;

    // showcase the recurring price of the selected pack
    recurringEl.innerHTML = price(pricing);

    // update the welcome headlines content and toggle their respective classes
    if (isSub) {
        discountHeadlines.forEach(headline => {
                headline.classList.add("activeDiscount");
                headline.innerHTML = `${checkSVG}<span>${welcomeDiscount.code} ${welcomeDiscount.percent}%</span> off auto-applied`
            }
        )
    } else {
        discountHeadlines.forEach(headline => {
            headline.classList.remove("activeDiscount");
            headline.innerHTML =
                `${checkSVG} Subscribe and get an additional ${welcomeDiscount.percent}% off`
        })
    }
    // show the elements tethered by subscription selected
    [subtotal, discountEl, recurringEl].forEach(el => el?.classList.toggle("active", isSub));
}

refreshForm();

document.querySelector("#productV2ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // exit if disabled
    if (this.classList.contains("disabled")) {
        return;
    }

    // collect formdata

    let formData = {
        id: parseInt(document.querySelector(".productV2Form.active").getAttribute("variant")),
        quantity: 1,
        properties: {
            '_added_at': Date.now() // When the line entered the cart, keeps the mini cart order stable
        }
    };

    // Subscription
    if (document.querySelector(`.productV2FormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productV2Form.active .productV2FormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // // clear cart
    // await fetch("/cart/clear.js");

    // add to cart
    await addProduct(formData);

    // open cart
    await openCart(false);

    // stop loading
    this.classList.remove("loading");
});

/*********************************** Stars *************/

document.querySelector("#productV2Stars").addEventListener("click", function () {
    // show reviews modal
    document.querySelector('#reviewsWidget').showModal();
    // no scroll
    document.body.classList.add("noScroll");
});

// preselect url
(async function () {
    if (urlParams.has("preselect_index")) {
        document.querySelectorAll(".productV2Form.active .productV2FormRollsItem")[urlParams.get("preselect_index")]?.click();
    }
}());
